import { withInstall } from '../utils/index';
import _Group from './group.vue';
import './index.less';

export const TlbsGroup = withInstall(_Group);
